export default __webpack_public_path__ + "static/media/Wolf's Boots of the Ritual Flame.00f222d4.jpg";